import React from 'react';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';
import DatePicker from 'material-ui/DatePicker';
import TextField from 'material-ui/TextField';
import {Link} from 'react-router';
import {observer} from 'mobx-react';


const contentStyle = {
  width: '500px',
  maxWidth: '100%',
};
/**
 * Dialogs can be nested. This example opens a Date Picker from within a Dialog.
 */
@observer(['state','actions'])
export default class SignupModal extends React.Component {


  render() {
    // const actions = [
    //   <FlatButton
    //     label="Ok"
    //     primary={true}
    //     keyboardFocused={true}
    //     onTouchTap={this.handleClose}
    //   />,
    // ];

    // <div>
    //   <RaisedButton label="Dialog With Date Picker" onTouchTap={this.handleOpen} />
    //   </div>

    return (

        <Dialog

          modal={false}
          open={this.props.open}
          onRequestClose={this.props.handleClose}
          contentStyle={contentStyle}
        >

        <button onClick={this.props.handleClose} className="pull-right clean_btn close_btn"><img src={require("../../img/x_icon.png")}/></button>
        <div className="modal_content signup_modal">
          {/*<h3 className="text-center">Signup</h3>*/}
          <br/>
          <br/>
          <br/>
          <h1 className="text-center">Coming soon!</h1>
          <br/>
          <br/>
          <p>In the meanwhile please <Link onTouchTap={this.props.handleClose} to="contact_us" >contact us</Link> </p>

        </div>
        </Dialog>

    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/SignupModal.js